import {
  Events,
  SuperpixelConfiguration,
  SuperpixelConfigurationModel,
} from '@mm/state/model/SuperpixelModel';
import Actions from '../actions/actions';
import superpixelConfigurationCRUDActions from '../actions/SuperpixelConfigurationCRUDActions';
import { setBusy, setUnBusy } from './common/commonReducers';

type ActionType = {
  type: string;
  entity: SuperpixelConfiguration;
  events: Events;
};

const initialState: SuperpixelConfigurationModel = {
  busy: false,
  configuration: null,
  events: {},
};

export const superpixelConfiguration = (
  state = initialState,
  action: ActionType,
) => {
  switch (action.type) {
    case superpixelConfigurationCRUDActions.busyAction:
      return setBusy(state);

    case superpixelConfigurationCRUDActions.retrievedAction: {
      return {
        ...state,
        configuration: action.entity,
        busy: false,
      };
    }
    case superpixelConfigurationCRUDActions.eventsRetrieved: {
      return {
        ...state,
        events: action.events,
        busy: false,
      };
    }
    case superpixelConfigurationCRUDActions.unbusyAction:
      return setUnBusy(state);
    case Actions.UNBUSY:
      return setUnBusy(state);
    default:
      return state;
  }
};
